<template>
  <div class="head-container">
    <p class="title">加工厂/供应商扣款处理明细表</p>
    <div class="head-line1">
      <div class="company">
        <span>
          扣款加工厂/供应商：
          <span class="footer-line">{{company.vendorName}}</span>
        </span>
      </div>
      <div class="company">
        <span>
          扣款单编号：
          <span class="footer-line">{{company.debitOrderNo}}</span>
        </span>
      </div>
    </div>
    <div class="head-line1">
      <span class="head-box">
        <span style="margin-right: 50px;">赫基集团公司代码</span>
        <span class="box"></span>
        珠海赫基服饰有限公司
      </span>
      <span class="head-box">
        <span class="box"></span>
        广州尚岑服饰有限公司
      </span>
      <span class="head-box">
        <span class="box"></span>
        广州赫斯汀服饰有限公司
      </span>
      <span>
        日期：
        <span class="footer-line">{{new Date().toLocaleDateString() + ' ' + new Date().toLocaleTimeString('it-IT')}}</span>
      </span>
    </div>
  </div>
</template>
<script>
export default {
  name: "print-company",
  props: {
    company: {
      type: Object,
      default: {},
    },
  },
};
</script>

<style scoped>
.head-container {
  font-size: 12px;
  margin-bottom: 10px;
  padding: 5px 40px 5px 2px;
  border: 1px solid #000;
}
.head-line1 {
  display: flex;
  justify-content: space-between;
}
.title {
  text-align: center;
  font-weight: 500;
  font-size: 12px;
}
.head-box {
  margin-right: 60px;
}
.box {
  display: inline-block;
  width: 10px;
  height: 10px;
  border: 1px solid #000;
}
.company {
  margin: 5px 0;
}
.company .code {
  margin: 0 20px;
}
.footer-line {
  width: 180px;
  display: inline-block;
  border-bottom: 1px solid #000;
}
</style>